import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import {
  updateQuizRequest,
  updateQuizRequestError,
  updateQuizRequestSuccess,
} from "../../../slices/teams/members/UpdateQuizSlice";

export const UpdateQuiz = (id, formData) => async (dispatch) => {
  try {
    dispatch(updateQuizRequest());
    const url = `${endpoints.updateQuiz}/${id}`;

    const response = await axiosInstance.put(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    dispatch(updateQuizRequestSuccess(response.data));
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Failed to update quiz";

    const _error = {
      data: errorMessage,
      status: error?.response?.status,
    };

    dispatch(updateQuizRequestError(_error));
    throw _error;
  }
};
